module.exports = __webpack_public_path__ + "img/iconexit.5c6498a8.svg";